function asBufferSource(bytes: Uint8Array): BufferSource {
  return bytes as unknown as BufferSource;
}

export function uint8ToBase64(bytes: Uint8Array): string {
  let bin = "";
  bytes.forEach((b) => (bin += String.fromCharCode(b)));
  return btoa(bin);
}

export function base64ToUint8(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

export async function hmacSha256Base64(message: string, keyBase64: string): Promise<string> {
  const keyBytes = base64ToUint8(keyBase64);
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    asBufferSource(keyBytes),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  const sig = await crypto.subtle.sign("HMAC", cryptoKey, new TextEncoder().encode(message));
  return uint8ToBase64(new Uint8Array(sig));
}

async function sha256Hex(input: string): Promise<string> {
  const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(input));
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export async function buildCanonicalString(
  method: string,
  servletPath: string,
  sortedQueryString: string,
  timestamp: string,
  nonce: string,
  encryptedBodyBase64: string,
): Promise<string> {
  const bodyHash = await sha256Hex(encryptedBodyBase64);
  return `${method.toUpperCase()}\n${servletPath}\n${sortedQueryString}\n${timestamp}\n${nonce}\n${bodyHash}`;
}

export function buildSortedQueryStringFromUrl(url: string): {
  servletPath: string;
  sortedQueryString: string;
} {
  const parsed = new URL(url);
  const pathname = parsed.pathname;
  const apiIdx = pathname.indexOf("/api/v1/secured/");
  const servletPath = apiIdx >= 0 ? pathname.slice(apiIdx) : pathname;
  const sortedQueryString = Array.from(parsed.searchParams.keys())
    .sort()
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(parsed.searchParams.get(key) ?? "")}`,
    )
    .join("&");
  return { servletPath, sortedQueryString };
}
